import React, { Component } from 'react';
import { Modal, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Link } from 'react-router-dom'; // Redirect
import classnames from 'classnames';
import axios from 'axios';
import { APIURL, IMAGE_FULL_URL, IMAGE_NOPHOTO_URL } from '../../../config/config';
import AgentFormModal from './AgentFormModal';
import Swal from "sweetalert2";
import { AlertSuccess } from '../../Alert/Alert';
import PreviewImage from '../../../views/PreviewImage';
import AgentByDate from '../AgentByDate'

class AgentList extends Component{
  constructor (props) {
    super(props)
    this.state = {
      activeTab: '2',
      isAgentModal: false,
      agent_list: [],
      agentSelected: null,
      preview_image_select: false,
      preview_image_url: ''
    }

    this.loadAgentData = this.loadAgentData.bind(this);
    this.toggleAgentModal = this.toggleAgentModal.bind(this);
    this.onDeleteAgent = this.onDeleteAgent.bind(this);
    this.onEditAgent = this.onEditAgent.bind(this);
    this.togglePreviewImage = this.togglePreviewImage.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount () {
    this.loadAgentData()
  }

  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select
    });
  }

  onRefresh(){
    this.refs.input_search.value = ''
    this.loadAgentData()
  }

  onSearch(){
    var search_text = this.refs.input_search.value

    if(search_text==='') {
      return;
    }

    if(search_text.length < 3){
      return;
    }

    axios.get( APIURL + '/agent/search/'+search_text )
      .then(res => {
        this.setState({agent_list: res.data})
      }).catch(error => {
      this.setState({agent_list: []})
    })

  }

  loadAgentData() {
    axios.get( APIURL + '/agent/').then(res => {
      this.setState({
        agent_list: res.data
      })
    }).catch(error => {

    })
  }

  onDeleteAgent(agent) {
    const agent_id = agent.agent_id
    // const agent_key = agent.agent_key

    Swal.fire({
      title: 'ยืนยันการลบ '+agent.agent_fullname + ' ',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        axios.post( APIURL + '/agent2/delete/'+agent_id, agent).then(res => {
          if(res.status === 200) {
            AlertSuccess('ลบข้อมูลเรียบร้อยแล้ว')
            this.loadAgentData()
          }
        }).catch(error => {

        })
      }
    });

  }

  onEditAgent(agent){
    this.setState({
      agentSelected: agent
    }, () => this.toggleAgentModal('แก้ไข'))
  }

  toggleAgentModal(actionType) {
    if(actionType === 'บันทึก') {
      this.setState({
        agentSelected: null,
        isAgentModal: !this.state.isAgentModal,
        actionType: actionType,
      })
    } else {
      // agentSelected
      this.setState({
        isAgentModal: !this.state.isAgentModal,
        actionType: actionType
      }, () => {
        if(actionType === 'success') {
          this.loadAgentData()
        }
      })
    }
  }

  onPreviewSelected(url){
    this.setState({
      preview_image_url: url,
      preview_image_select: true
    });
  }


  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render () {

    // agent.agent_id
    const emptyData = <tr><td colSpan={8} className="text-center text-danger"> ไม่พบข้อมูล </td></tr>
    const agent_list = this.state.agent_list.map((agent, index) => {

      let image_url = '';

      if (agent.agent_file===null) {
        image_url = IMAGE_NOPHOTO_URL
      } else {
        if(agent.agent_file.includes('https')) {
          image_url = agent.agent_file;
        } else {
          image_url = IMAGE_FULL_URL+agent.agent_file;
        }
      }

      return (
        <tr key={index}>
          <td className="text-center">{ agent.agent_id }</td>
          <td>
            <img
              src={image_url}
              style={{'cursor' : 'pointer', 'width': '120px', 'height': 'auto'}}
              onClick={()=>{
                if(agent.agent_file !=='')
                  this.onPreviewSelected(image_url)
              }}
              alt="เอกสาร"
            />
          </td>
          <td>{ agent.agent_fullname }</td>
          <td>{ agent.agent_card_id }</td>
          <td>{ agent.agent_address }</td>
          <td>{ agent.agent_mobile }</td>
          <td>

            <Link to={'/agent/detail/?agent_id='+agent.agent_id} target='_blank' type="button"
                  className="btn btn-info btn-sm btn-block">
              <i className="fa fa-list"/>
            </Link>

          </td>
          <td className="text-left" >

            <button className="btn btn-sm btn-warning btn-md-width mr-2 mb-2"
                    onClick={() => this.onEditAgent(agent)}
            >
              <i className="fa fa-edit"/> แก้ไข
            </button>

            {agent.car_sell_id === null ?
              <button className={"btn btn-sm btn-danger btn-md-width mb-2" }
                      onClick={() => this.onDeleteAgent(agent)}
              >
                <i className="fa fa-remove"/> ลบ
              </button> : null
            }

          </td>
        </tr>
      );
    })

    const agentList = this.state.agent_list.length > 0 ? agent_list : emptyData

    return (
      <div className="col-md-12 mb-4">

        <AgentFormModal
          isAgentModal={this.state.isAgentModal}
          toggleAgentModal={this.toggleAgentModal}
          actionType={this.state.actionType}
          agentSelected={this.state.agentSelected}
        />

        <Modal isOpen={this.state.preview_image_select} toggle={this.togglePreviewImage} className={'modal-lg '}>
          <ModalBody>
            <PreviewImage
              imageUrl={this.state.preview_image_url}
            />
          </ModalBody>
        </Modal>

        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              <i className="icon-options-vertical"/> ข้อมูลนายหน้า
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              <i className="icon-check"/> รายการรถที่ขายผ่านนายหน้า
            </NavLink>
          </NavItem>

        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-sm-12 col-md-12">
                <div className="card card-accent-success">
                  <div className="card-header card-customer">
                    <strong className="text-title"> ข้อมูลนายหน้า </strong>

                    <input
                      onChange={this.onSearch.bind(this)}
                      ref="input_search"
                      style={styles.inputSearch}
                      className="form-control"
                      placeholder="ค้นหาตามชื่อ หรือ เบอร์โทร"
                      type="text"
                    />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <button className="btn btn-head-bar"
                            style={styles.buttonHeight}
                            onClick={this.onRefresh.bind(this)}
                    >
                      <i className="icon-refresh"/>
                    </button>

                    <button type="button" onClick={() => this.toggleAgentModal('บันทึก')} className="btn btn-head-bar float-right mt-1">
                      <i className="icon-user-follow"/>&nbsp;เพิ่มข้อมูลนายหน้า
                    </button>
                  </div>

                  <div className="card-block">
                    <table className="table table-striped">
                      <thead>
                      <tr>
                        <th className="text-center">#</th>
                        <th >รูปภาพ</th>
                        <th >ชื่อ-นามสกุล</th>
                        <th >เลขประจำตัวประชาชน</th>
                        <th >ที่อยู่ปัจจุบัน</th>
                        <th >เบอร์โทรศัพท์</th>
                        <th >รายละเอียด</th>
                        <th className="text-center">จัดการ</th>
                      </tr>
                      </thead>
                      <tbody>
                       {agentList}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </TabPane>

          <TabPane tabId="2">
            <AgentByDate

            />
          </TabPane>

        </TabContent>
      </div>
    )
  }
}

const styles = {
  inputSearch: {
    marginLeft: 20,
    width: 300,
    display: 'inline'
  },

  buttonHeight: {
    height: 36,
    paddingTop:0,
    paddingBottom:0,
    display: 'inline',
    marginTop: '-0.35rem'
  }
}

export default AgentList
